import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { endpoint } from "../../../utils/constants/endpoint";
import { headersBase, headersType } from "../../../utils/constants/headersForApi";

export const managementNewsApi = createApi({
  reducerPath: "managementNews",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["news", "singleNews"],
  endpoints: (builder) => ({
    getManagementNews: builder.query({
      query: ({ page: { startRow, endRow }, newsFilter = "" }) => ({
        url: `admin/News/list?query=${newsFilter}`,
        method: "POST",
        headers: headersType(),
        body: { startRow, endRow },
      }),
      providesTags: ["news"],
    }),

    getCategoryNews: builder.query({
      query: () => ({
        url: "admin/enums/newscategories",
        method: "GET",
        headers: headersBase()
      }),
    }),
    getProfileCategory: builder.query({
      query: () => ({
        url: "admin/enums/employmenttypes",
        method: "GET",
        headers: headersBase()
      }),
    }),

    getSingleNews: builder.query({
      query: (id) => ({
        url: "/admin/news/" + id,
        method: "GET",
        headers: headersBase()
      }),
      providesTags: ["singleNews"],
    }),

    getUploadURL: builder.query({
      query: () => ({
        url: "admin/News/getuploadurl",
        method: "GET",
        headers: headersBase()
      }),
    }),
    createNews: builder.mutation({
      query: (news) => ({
        url: endpoint.ADMIN_NEWS.NEWS,
        method: "POST",
        headers: headersType(),
        body: news,
      }),
      invalidatesTags: ["news"],
    }),
    deleteNews: builder.mutation({
      query: (id) => ({
        url: endpoint.ADMIN_NEWS.NEWS + "/" + id,
        method: "DELETE",
        headers: headersBase(),
        body: id,
      }),
      invalidatesTags: ["news"],
    }),
    publishNews: builder.mutation({
      query: (id) => ({
        url: endpoint.ADMIN_NEWS.NEWS + "/" + id + "/publish",
        method: "POST",
        headers: headersType(),
        body: id,
      }),
      invalidatesTags: ["news"],
    }),
    editNews: builder.mutation({
      query: (news) => ({
        url: `${endpoint.ADMIN_NEWS.NEWS}/${news.Id}`,
        method: "PUT",
        headers: headersType(),
        body: news,
      }),
      invalidatesTags: ["news", "singleNews"],
    }),
    deleteImageNews: builder.mutation({
      query: (id) => ({
        url: endpoint.ADMIN_NEWS.NEWS + "/" + id + "/deleteimage",
        method: "POST",
        headers: headersType(),
        body: id,
      }),
      invalidatesTags: ["singleNews"],
    }),
  }),
});

export const {
  useGetManagementNewsQuery,
  useGetCategoryNewsQuery,
  useGetSingleNewsQuery,
  useGetProfileCategoryQuery,
  useGetUploadURLQuery,
  useCreateNewsMutation,
  useDeleteNewsMutation,
  usePublishNewsMutation,
  useEditNewsMutation,
  useDeleteImageNewsMutation,
} = managementNewsApi;
